import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Header from "../../components/Header";
import EcoEarnRetailer from "../../components/EcoEarnRetailer";
import Firebase from "../../firebasehelper";
import FilterTab from "../super_offers/components/FilterTab";
import AddRetailerModal from "../../components/Retailer/AddRetailerModal";
import Grid from "@material-ui/core/Grid";

import "./index.css";
import { TerritoryOptions } from "../../Constants/retailer";
import EditEcoEarning from "../../components/EditEcoEarning";
const UKIcon = require("../../assets/media/countries/uk.png");
const USAIcon = require("../../assets/media/countries/usa.png");
const IrelandIcon = require("../../assets/media/countries/ireland.png");
const CanadaIcon = require("../../assets/media/countries/canada.png");
const AustraliaIcon = require("../../assets/media/countries/australia.png");
const FranceIcon = require("../../assets/media/countries/france.png");
const GermanIcon = require("../../assets/media/countries/german.png");
const IndiaIcon = require("../../assets/media/countries/india.png");
const SouthAfricaIcon = require("../../assets/media/countries/south-africa.png");

const TerritoryIcon = {
  UK: UKIcon,
  Ireland: IrelandIcon,
  USA: USAIcon,
  Canada: CanadaIcon,
  Australia: AustraliaIcon,
  German: GermanIcon,
  France: FranceIcon,
  India: IndiaIcon,
  SouthAfrica: SouthAfricaIcon,
};
class SuperEcoEarnRetailers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      deactive: [],
      tag: "Top 20",
      selectedTerritory:
        this.props.location.state.selectedTerritory || TerritoryOptions[0],
      retailerToEdit: null,
    };
  }
  componentDidMount() {
    if (!this.props.location.state && this.props.location.state.role !== 0) {
      this.props.history.push("/");
    } else {
      console.log("---", this.props.location);
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
    }
    Firebase.getAllEcoEarnRetailers((res) => {
      console.log("all eco earn retailers", res);
      const keys = Object.keys(res);
      const retailers = keys.map((key) => ({
        ...res[key],
        id: key,
      }));
      retailers.sort((a, b) => {
        var textA = a.retailerName.toUpperCase();
        var textB = b.retailerName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      this.setState({ retailers });
    });
    Firebase.getAllDeactiveEcoEarnRetailers((res) => {
      let deactive = [];
      if (res) deactive = res;
      this.setState({ deactive });
    });
  }

  filter_View = (tag) => {
    this.setState({ tag });
  };

  toggleRetailer = (index) => {
    let { deactive } = this.state;
    deactive[index] = !deactive[index];
    Firebase.updateDeactiveEcoEarnRetailers(deactive);
  };

  editEarningValue = async (retailer) => {
    const { brand } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    console.log("brand", brand);

    this.setState({ retailerToEdit: retailer });

    // this.props.history.push({
    //   pathname: `/retailer-details`,
    //   search: `?retailerId=${retailerId}`,
    //   state: {
    //     username,
    //     role,
    //     brand,
    //   },
    // });
  };

  territoryFilterUpdated = (selectedTerritory) => () => {
    this.setState({ selectedTerritory });
  };

  showRetailers = () => {
    const { retailers, deactive, selectedTerritory } = this.state;
    let username = this.props.location.state.username;

    let filteredRetailerKeys = [];

    if (this.props.location.pathname !== "/earn-tokens") {
      console.log("retailers", retailers);
      filteredRetailerKeys = retailers.map((r) => r.id);
    } else {
      filteredRetailerKeys = retailers
        .map((r) => r.id)
        .filter((obj) => !deactive[obj]);
    }
    console.log("filteredRetailerKeys", filteredRetailerKeys);
    return filteredRetailerKeys.map((key, index) => {
      const retailer = retailers.find((r) => r.id === key);
      const territory = retailer.territory || TerritoryOptions[0];
      if (territory !== selectedTerritory) {
        return null;
      }
      return (
        <EcoEarnRetailer
          key={index}
          deactive={deactive[retailer.id] ? "deactive" : "activate"}
          username={username}
          retailer={retailer}
          retailers={retailers}
          onClick={() => this.toggleRetailer(retailer.id)}
          onEdit={this.editEarningValue}
          id={retailer.id}
          showEdit={this.props.location.pathname !== "/earn-tokens"}
        />
      );
    });
  };

  uploadContent = async (mediaContent) => {
    const title = new Date().getTime().toString();
    this.setState({ loading: true });
    let img_url = await Firebase.uploadImage(
      mediaContent,
      title,
      "eco_earn" + this.state.retailerToEdit.retailerName + "/images"
    );
    this.setState({ loading: false });
    this.handleSetMediaURL(img_url);
  };

  onSaveRetailer = async (newValue, content) => {
    const { retailerToEdit } = this.state;
    console.log("retailerToUpdate", retailerToEdit);
    if (content) {
      const title = new Date().getTime().toString();
      this.setState({ loading: true });
      let img_url = await Firebase.uploadImage(
        content,
        title,
        "eco_earn/" + this.state.retailerToEdit.retailerName + "/images"
      );
      Firebase.updateEcoEarnRetailer(
        { tokenPercentage: newValue.toString(), logo: img_url },
        retailerToEdit.id
      );
      this.setState({ loading: false });
    } else {
      Firebase.updateEcoEarnRetailer(
        { tokenPercentage: newValue.toString() },
        retailerToEdit.id
      );
    }
  };

  render() {
    const { retailers, logo, brand, selectedTerritory, tag } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <main id="main-container">
          <div className="eco-earn-content">
            {retailers.length ? (
              <React.Fragment>
                {/* <h4>
                  Click the retailer icon to change active or inactive status.
                </h4> */}
                {this.props.location.pathname !== "/earn-tokens" && (
                  <div className="territory-filter-container">
                    {TerritoryOptions.map((territory) => (
                      <button
                        className={classNames("btn territory-btn", {
                          selected: selectedTerritory === territory,
                        })}
                        disabled={territory !== "UK" && territory !== "USA"}
                        onClick={this.territoryFilterUpdated(territory)}
                      >
                        <img src={TerritoryIcon[territory]} alt="flag" />
                      </button>
                    ))}
                  </div>
                )}
                <div container className="eco-earn-retailer-list">
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      <p
                        style={{
                          color: "black",
                          fontSize: "25px",
                          fontWeight: "800",
                          textAlign: "center",
                        }}
                      >
                        Retailer
                      </p>
                    </Grid>
                    <Grid item xs={2}>
                      <p
                        style={{
                          color: "black",
                          fontSize: "25px",
                          fontWeight: "800",
                          textAlign: "center",
                        }}
                      >
                        Tokens
                      </p>
                      <p
                        style={{
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "bold",
                          lineHeight: "0",
                          textAlign: "center",
                        }}
                      >
                        per 1 spent
                      </p>
                    </Grid>
                    <Grid item xs={3}>
                      <p
                        style={{
                          color: "black",
                          fontSize: "25px",
                          fontWeight: "800",
                          textAlign: "center",
                        }}
                      >
                        Total earnings
                      </p>
                    </Grid>
                    {this.props.location.pathname !== "/earn-tokens" && (
                      <Grid item xs={2}>
                        <p
                          style={{
                            color: "black",
                            fontSize: "25px",
                            fontWeight: "800",
                            textAlign: "center",
                          }}
                        >
                          Status
                        </p>
                      </Grid>
                    )}
                    {this.props.location.pathname !== "/earn-tokens" && (
                      <Grid item xs={2}>
                        <p
                          style={{
                            color: "black",
                            fontSize: "25px",
                            fontWeight: "800",
                            textAlign: "center",
                          }}
                        >
                          Update
                        </p>
                      </Grid>
                    )}
                  </Grid>
                  {this.showRetailers()}
                </div>
              </React.Fragment>
            ) : (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            )}
          </div>
        </main>
        <EditEcoEarning
          retailer={this.state.retailerToEdit}
          onSave={this.onSaveRetailer}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapActionToProps = (dispatch) => ({});
export default connect(
  mapStateToProps,
  mapActionToProps
)(SuperEcoEarnRetailers);



// WEBPACK FOOTER //
// ./src/screens/SuperEcoEarnRetailers/index.js